import fr from 'facet-rest';
import DefaultLayoutOverride from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/Default/MetaOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import DateFieldStandardized from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import { moment } from 'Helpers/DateTime';

const IncomeStepOverride = fr.metaOverride({ base: DefaultLayoutOverride })
  .nameOverride('endDate', {
    _customProps: {
      helperText: 'If left blank, income will recur indefinitely',
    },
  })
  .override({ hint: 'yearMonth' }, {
    _component: () => DateFieldStandardized,
    _customProps: { format: 'MM/YYYY', placeholder: 'MM/YYYY', views: ['year', 'month'] },
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment(v).utc().startOf('month').toISOString();
    },
  }, overrideReadOnly);

export default IncomeStepOverride;
